/** @jsxImportSource @emotion/react */

import IconMaintain from "assets/desktop/images/icon_maintain.png";

import { WithdrawAttentionStyle } from "./index.style";

const WithdrawAttention = () => {
  
  return (
    <div css={WithdrawAttentionStyle.self}>
      <div css={WithdrawAttentionStyle.header}>
        <img loading="lazy" src={IconMaintain} alt="" />
        {"注意"}
      </div>
      <div css={WithdrawAttentionStyle.desc}>
        <ol>
          <li>所有託售必須符合本網站的託售政策</li>
          <li>
            <div className="decimal">1.</div>
            <div>首次託售申請後請與客服聯繫。</div>
          </li>
          <li>
            <div className="decimal">2.</div>
            <div>
              每次託售最低需1000點數以上，綁定銀行卡戶名需與註冊姓名一致。
            </div>
          </li>
          <li>
            <div className="decimal">3.</div>
            <div>
              如儲值未達到全額投注，即無法通過託售審核，託售申請將會被駁回。
            </div>
          </li>
          <li>
            <div className="decimal">4.</div>
            <div>託售銀行帳戶戶名需與儲值帳戶戶名相同。</div>
          </li>
          <li>
            <div className="decimal">5.</div>
            <div>
              如有任何利用本公司不法洗碼等詐騙行為，將終止會員服務並凍結其帳戶。
            </div>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default WithdrawAttention;
